import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { createCart } from './create-cart'

export const useCreateCart = (): void => {
    const { locale } = useRouter()
    useEffect(() => {
        createCart({ locale })
    }, [])
}
